import ICountUp from 'vue-countup-v2'
import NumberCounter from './NumberCounter'
import ScrollObserver from './ScrollObserver'

const Components = {
  install: (Vue) => {
    Vue.component('ICountUp', ICountUp)
    Vue.component('NumberCounter', NumberCounter)
    Vue.component('ScrollObserver', ScrollObserver)
  },
}

export default Components
